import React from "react";
import QuestionPostCard from "../questions/QuestionPostCard";

export default function QuestionCard(props) {
  return (
    <div className="col-md-6 col-lg-3 col-sm-12 d-flex">
      <QuestionPostCard question={props.questions} compact />
    </div>
  );
}
